<ul class="d-flex flex-wrap">
  <li class="mr-2 selected">
    <span (click)="switchLanguage()">{{"LangSwitcher.CurrentLang" | translate}}</span>
  </li>
</ul>
